<div class="card card-about bg-dark text-dark">
    <img src="/assets/img/header3.jpg" class="card-img" alt="About the project">
    <div class="overlay-div"></div>
  </div>
<div class="container">
<app-persona></app-persona>
</div>